import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";
import { dataabout, aboutstats, worktimeline } from "../../content_option";
import Reveal from "../../components/reveal";

const StatValue = ({ value }) => {
  const match = /^(\d+)(\+?)$/.exec(value);
  const numericValue = match ? Number(match[1]) : null;
  const suffix = match ? match[2] : "";
  const [count, setCount] = useState(numericValue === null ? null : 0);
  const valueRef = useRef(null);

  useEffect(() => {
    if (numericValue === null) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setCount(numericValue);
      return undefined;
    }

    let frameId;
    let startedAt;
    let isRunning = false;
    const runCounter = (timestamp) => {
      if (startedAt === undefined) startedAt = timestamp;
      const progress = Math.min((timestamp - startedAt) / 900, 1);
      const easedProgress = 1 - (1 - progress) ** 3;
      setCount(Math.floor(easedProgress * numericValue));
      if (progress < 1 && isRunning) frameId = window.requestAnimationFrame(runCounter);
    };
    const start = () => {
      if (isRunning) return;
      isRunning = true;
      startedAt = undefined;
      setCount(0);
      frameId = window.requestAnimationFrame(runCounter);
    };

    if (typeof IntersectionObserver === "undefined") {
      start();
      return () => window.cancelAnimationFrame(frameId);
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        start();
      } else if (isRunning) {
        isRunning = false;
        window.cancelAnimationFrame(frameId);
        setCount(0);
      }
    }, { threshold: 0.6 });
    if (valueRef.current) observer.observe(valueRef.current);

    return () => {
      observer.disconnect();
      window.cancelAnimationFrame(frameId);
    };
  }, [numericValue]);

  return <span ref={valueRef}>{numericValue === null ? value : `${count ?? 0}${suffix}`}</span>;
};

export const About = () => {
  return (
    <section id="about" className="About-header">
      <Container>
        <Row className="mb-4 mt-3 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4">About me</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>

        <Row className="sec_sp align-items-center">
          <Col lg="5">
            <Reveal>
              <h3 className="color_sec ab_heading">{dataabout.title}</h3>
            </Reveal>
          </Col>
          <Col lg="7">
            <Reveal delay={120}>
              <p className="ab_text">{dataabout.aboutme}</p>
            </Reveal>
          </Col>
        </Row>

        <Row className="ab_stats sec_sp">
          {aboutstats.map((s, i) => (
            <Col xs="6" lg="3" key={i} className="mb-3">
              <Reveal delay={i * 80} className="ab_stat glass">
                <span className="ab_stat_val grad-text"><StatValue value={s.value} /></span>
                <span className="ab_stat_label">{s.label}</span>
              </Reveal>
            </Col>
          ))}
        </Row>

        <Row className="sec_sp">
          <Col lg="4">
            <h3 className="color_sec ab_heading">Work Timeline</h3>
          </Col>
          <Col lg="8">
            <div className="ab_timeline">
              {worktimeline.map((data, i) => (
                <Reveal key={i} delay={i * 80} className="ab_tl_item glass">
                  <div className="ab_tl_role">{data.jobtitle}</div>
                  <div className="ab_tl_meta">
                    <span className="ab_tl_where">{data.where}</span>
                    <span className="ab_tl_date">{data.date}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
